import { render, staticRenderFns } from "./WsInfoBelongsToMany.vue?vue&type=template&id=0ee19d3a&"
import script from "./WsInfoBelongsToMany.vue?vue&type=script&lang=js&"
export * from "./WsInfoBelongsToMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports